<div class="request-demo">
  <div class="header">REQUEST A DEMO</div>
  <div class="content">
    <form #requestDemoForm="ngForm" (ngSubmit)="onSubmitForm(requestDemoForm)">
      <table>
        <tr class="table-header">
          <td colspan="2">Personal Details:</td>
          <td colspan="2">Customer Details:</td>
          <td colspan="2">Channels Details:</td>
        </tr>
        <tr>
          <td class="field-title short">
            FIRST NAME:<span class="red">*</span>
          </td>
          <td>
            <input
              tabindex="1"
              type="text"
              placeholder=""
              [(ngModel)]="formData.personalDetails.firstName"
              name="firstName"
              required
              minlength="1"
              maxlength="30"
            />
            <span
              class="errorMsg"
              [hidden]="verifyField('firstName', 'required')"
              >Required field</span
            >
          </td>
          <td class="field-title short">COMPANY:<span class="red">*</span></td>
          <td>
            <input
              tabindex="7"
              type="text"
              placeholder=""
              [(ngModel)]="formData.customerDetails.companyName"
              name="company"
              required
              minlength="1"
              maxlength="30"
            />
            <span class="errorMsg" [hidden]="verifyField('company', 'required')"
              >Required field</span
            >
          </td>
          <td class="field-title long">
            How many channels are you broadcasting right now?
          </td>
          <td class="very-short">
            <input
              tabindex="11"
              type="number"
              min="0"
              max="100000"
              placeholder="0"
              [(ngModel)]="formData.channelsDetails.broadcastingChannels"
              name="broadcastingChannels"
            />
          </td>
        </tr>

        <tr>
          <td class="field-title short">
            <span class="label"> LAST NAME:<span class="red">*</span> </span>
          </td>
          <td>
            <input
              tabindex="2"
              type="text"
              placeholder=""
              [(ngModel)]="formData.personalDetails.lastName"
              name="lastName"
              required
              minlength="1"
              maxlength="30"
            />
            <span
              class="errorMsg"
              [hidden]="verifyField('lastName', 'required')"
              >Required field</span
            >
          </td>
          <td class="field-title short">TITLE:</td>
          <td>
            <input
              tabindex="8"
              type="text"
              placeholder=""
              [(ngModel)]="formData.customerDetails.title"
              name="title"
            />
          </td>
          <td class="field-title long">
            How many channels do you plan to launch in the next 12 months?
          </td>
          <td class="very-short">
            <input
              tabindex="12"
              type="number"
              min="0"
              max="100000"
              placeholder="0"
              [(ngModel)]="formData.channelsDetails.channelsToLaunch"
              name="channelsToLaunch"
            />
          </td>
        </tr>

        <tr>
          <td class="field-title short">EMAIL:<span class="red">*</span></td>
          <td>
            <input
              tabindex="3"
              type="email"
              placeholder=""
              [(ngModel)]="formData.personalDetails.email"
              email
              (blur)="validateEmailExists($any($event.target).value)"
              name="email"
              required
              minlength="1"
              maxlength="50"
            />
            <span
              class="errorMsg"
              [hidden]="verifyField('email', 'usernameExists')"
              >This email already has been taken</span
            >
            <!--<span class="errorMsg" [hidden]="verifyField('email','required')">Required field</span>-->
            <span class="errorMsg" [hidden]="verifyField('email', 'email')"
              >Email is required and format should be
              <i>john&#64;doe.com</i></span
            >
          </td>
          <td class="field-title short">COUNTRY:</td>
          <td>
            <icn-dropdown
              [position]="'bottom'"
              tabindex="9"
              class="dropdown"
              (selectedValueChange)="
                formData.customerDetails.countryId = $event
              "
              [selectedValue]="formData.customerDetails.countryId"
            >
              <icn-dropdown-item
                [title]="'Select Country'"
                [value]="-1"
              ></icn-dropdown-item>
              <icn-dropdown-item
                *ngFor="let country of countries"
                [title]="country.name"
                [value]="country.id"
              ></icn-dropdown-item>
            </icn-dropdown>
          </td>
          <td class="field-title long">CHOOSE YOUR CHANNEL RESOLUTION</td>
          <td class="very-short">
            <icn-dropdown
              [position]="'bottom'"
              tabindex="13"
              class="very-short"
              (selectedValueChange)="
                formData.channelsDetails.channelResolution = $event
              "
              [selectedValue]="formData.channelsDetails.channelResolution"
            >
              <icn-dropdown-item
                [title]="'Select Resolution'"
                [value]="''"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'SD'"
                [value]="'SD'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'HD'"
                [value]="'HD'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'FullHD'"
                [value]="'FullHD'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'4K'"
                [value]="'4K'"
              ></icn-dropdown-item>
            </icn-dropdown>
          </td>
        </tr>

        <tr>
          <td class="field-title short">PHONE:<span class="red">*</span></td>
          <td>
            <input
              tabindex="4"
              type="tel"
              placeholder=""
              [(ngModel)]="formData.personalDetails.phone"
              name="phone"
              pattern="(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$"
              required
            />
            <span class="errorMsg" [hidden]="verifyField('phone', 'required')"
              >Required field</span
            >
            <span class="errorMsg" [hidden]="verifyField('phone', 'pattern')"
              >Phone number isn't valid</span
            >
          </td>
          <td class="field-title short">INDUSTRY:</td>
          <td>
            <icn-dropdown
              [position]="'bottom'"
              tabindex="10"
              class="dropdown"
              (selectedValueChange)="formData.customerDetails.industry = $event"
              [selectedValue]="formData.customerDetails.industry"
            >
              <icn-dropdown-item
                [title]="'Select Industry'"
                [value]="''"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'Sport'"
                [value]="'Sport'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'Life style'"
                [value]="'Life style'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'Movies'"
                [value]="'Movies'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'Documentary'"
                [value]="'Documentary'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'News'"
                [value]="'News'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'Adult'"
                [value]="'Adult'"
              ></icn-dropdown-item>
            </icn-dropdown>
          </td>

          <td class="field-title long">AUDIO LANGUAGES IN CHANNELS?</td>
          <td>
            <icn-dropdown
              tabindex="14"
              [position]="'bottom'"
              [allowMultiple]="true"
              [selectedValues]="
                formData.channelsDetails.audioLanguagesInChannels
              "
              (selectedValuesChange)="
                formData.channelsDetails.audioLanguagesInChannels = $event
              "
            >
              <icn-dropdown-item
                *ngFor="let lang of languages"
                [value]="lang.code"
                [title]="lang.name"
              >
              </icn-dropdown-item>
            </icn-dropdown>
          </td>
        </tr>

        <tr>
          <td class="field-title short">PASSWORD:<span class="red">*</span></td>
          <td>
            <input
              tabindex="5"
              type="password"
              placeholder=""
              [(ngModel)]="formData.personalDetails.password"
              name="password"
              pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\D]{8,}$"
              required
              maxlength="30"
            />
            <span
              class="errorMsg"
              [hidden]="verifyField('password', 'required')"
              >Required field</span
            >
            <span class="errorMsg" [hidden]="verifyField('password', 'pattern')"
              >Password must be at least 8 characters and contain at least one
              number</span
            >
          </td>
          <td colspan="2"></td>
          <td class="field-title long">SUBTITLES LANGUAGES IN CHANNELS?</td>
          <td>
            <icn-dropdown
              tabindex="15"
              [position]="'bottom'"
              [allowMultiple]="true"
              [selectedValues]="
                formData.channelsDetails.subtitlesLanguagesInChannels
              "
              (selectedValuesChange)="
                formData.channelsDetails.subtitlesLanguagesInChannels = $event
              "
            >
              <icn-dropdown-item
                *ngFor="let lang of languages"
                [value]="lang.code"
                [title]="lang.name"
              >
              </icn-dropdown-item>
            </icn-dropdown>
          </td>
        </tr>
        <tr>
          <td class="field-title short">
            CONFIRM PASSWORD:<span class="red">*</span>
          </td>
          <td>
            <input
              tabindex="6"
              type="password"
              placeholder=""
              [(ngModel)]="formData.personalDetails.confirmPassword"
              name="confirmPassword"
              validateEqual="password"
              required
              minlength="1"
              maxlength="30"
            />
            <span
              class="errorMsg"
              [hidden]="verifyField('confirmPassword', 'required')"
              >Required field</span
            >
            <span
              class="errorMsg"
              [hidden]="verifyField('confirmPassword', 'validateEqual')"
              >Password mismatch</span
            >
          </td>

          <td colspan="3"></td>
          <td>
            <div class="btn-back" (click)="(isFormValid)">
              <span class="back">Next</span>
              <button
                type="submit"
                [disabled]="!isFormValid"
                tabindex="15"
                class="rounded-btn-prev rounded-btn-next"
                role="button"
              ></button>
            </div>
          </td>
        </tr>
      </table>
    </form>
  </div>
</div>
